import { Injectable } from '@angular/core';
import * as Slideout from 'slideout/dist/slideout';

@Injectable()

export class PageHeaderService {
  private SlideoutMenu: any;
  private SlideoutProfile: any;
  private SlideoutSettings = {
    padding: 270,
    tolerance: 100,
    duration: 400,
    touch: false
  };

  constructor() {
  }


  /**
   * Initialize of Slideout plugin.
   * Hook: close slideout of router events.
   */
  onSlideout(): void {
    setTimeout(() => {
      this.onSlideoutMenu();
      this.onSlideoutProfile();
    }, 100)
  }


  /**
   * Build of main Menu Slideout.
   * @params {
      padding
      tolerance
      duration
      touch
   * }
   */
  onSlideoutMenu(): void {
    if (this.slideoutLayout && this.slideoutMenuContainer) {
      this.SlideoutMenu = new Slideout(
        Object.assign(
          {
            panel: this.slideoutLayout,
            menu: this.slideoutMenuContainer
          }, this.SlideoutSettings
        )
      );
      this.onSlideoutMenuHandler();
    }
  }

  /**
   * Build of main Profile Slideout.
   * @params {
      padding
      tolerance
      duration
      touch
      side
   * }
   */
  onSlideoutProfile(): void {
    if (this.slideoutLayout && this.slideoutProfileContainer) {
      this.SlideoutProfile = new Slideout(
        Object.assign(
          {
            panel: this.slideoutLayout,
            menu: this.slideoutProfileContainer,
            side: 'right',
          }, this.SlideoutSettings
        )
      );
      this.onSlideoutProfileHandler();
    }
  }

  /**
   * Event of closing Menu Slideout.
   */
  onSlideoutMenuClose(): void {
    this.SlideoutMenu && this.SlideoutMenu.isOpen() ? this.SlideoutMenu.close() : null;
  }

  /**
   * Event of visibility Menu Slideout.
   */
  onSlideoutMenuVisible(): void {
    if (this.SlideoutProfile.menu) {
      this.SlideoutProfile.menu.style.visibility = 'hidden';
      this.SlideoutProfile.menu.classList.remove('view');
    }

    if (this.SlideoutMenu.menu.style) {
      this.SlideoutMenu.menu.style.visibility = 'visible';
      this.SlideoutMenu.menu.classList.add('view');
    }
  }

  /**
   * Toggle of view Menu Slideout.
   */
  onSlideoutMenuToggle(): void {
    this.slideoutMenuLink.classList.toggle('active');
    this.SlideoutMenu.toggle();
    this.onSlideoutMenuVisible();
  }

  /**
   * Base event handler of Menu Slideout.
   * @open
   * @close
   * @translatestart
   */
  onSlideoutMenuHandler(): void {
    this.SlideoutMenu
      .on('open', e => {
        if (this.slideoutMenuLink) {
          this.slideoutMenuLink.classList.add('active');
        }
        this.onSlideoutProfileClose();
      })
      .on('close', e => {
        if (this.slideoutMenuLink) {
          this.slideoutMenuLink.classList.remove('active');
          this.SlideoutMenu.menu.classList.remove('view');
        }

        this.onSlideoutProfileClose();
      })
      .on('translatestart', e => {
        this.onSlideoutMenuVisible();
      });
  }
  
  /**
   * Event of closing Profile Slideout.
   */
  onSlideoutProfileClose(): void {
    this.SlideoutProfile && this.SlideoutProfile.isOpen() ? this.SlideoutProfile.close() : null;
  }

  /**
   * Event of visibility Profile Slideout.
   */
  onSlideoutProfileVisible(): void {
    if (this.SlideoutProfile.menu.style) {
      this.SlideoutProfile.menu.style.visibility = 'visible';
      this.SlideoutProfile.menu.classList.add('view');
    }

    if (this.SlideoutMenu.menu.style) {
      this.SlideoutMenu.menu.style.visibility = 'hidden';
      this.SlideoutMenu.menu.classList.remove('view');
    }
  }

  /**
   * Base event handler of Profile Slideout.
   * @open
   * @close
   * @translatestart
   */
  onSlideoutProfileHandler(): void {
    this.SlideoutProfile
      .on('open', e => {
        this.onSlideoutMenuClose();
      })
      .on('close', e => {
        if (this.slideoutMenuLink) {
          this.slideoutMenuLink.classList.remove('active');
          this.SlideoutProfile.menu.classList.remove('view');
        }
        this.onSlideoutMenuClose();
      })
      .on('translatestart', e => {
        this.onSlideoutProfileVisible();
      });
  }

  /**
   * Toggle of view Profile Slideout.
   */
  onSlideoutProfileToggle(): void {
    this.SlideoutProfile.toggle();
    this.onSlideoutProfileVisible();
  }

  /**
   * Clear of Slideout DOM elements.
   */
  onSlideoutClear(): void {
    setTimeout(() => {
      const $html: HTMLCollection = document.getElementsByTagName('html');

      for (const i of Object.keys($html)) {
        $html[i].classList.remove('slideout-open');
      }
    }, 0);
  }

  
  private get slideoutMenuLink(): HTMLElement {
    return document.getElementById('pgLayoutMenuLink') || null;
  }

  private get slideoutMenuContainer(): HTMLElement {
    return document.getElementById('pgLayoutMenuContainer') || null;
  }

  private get slideoutProfileContainer(): HTMLElement {
    return document.getElementById('pgLayoutProfileContainer') || null;
  }

  private get slideoutLayout(): HTMLElement {
    return document.getElementById('pgLayoutContent') || null;
  }
}
